import { each } from 'lodash';
import { runBasePreload } from '../../common/logic/generalPreload';

const runPreload = (data, scorings, attributes, concepts, dispatchChangeLoadingState) => {
  runBasePreload(data, dispatchChangeLoadingState, (baseSrcList) => {
    const hasConcepts = !!concepts && !!concepts.length;
    const hasScorings = !!scorings && !!scorings.length;
    const hasAttributes = !!attributes && !!attributes.length;

    if ((hasScorings || hasAttributes) && hasConcepts) {
      each(concepts, (concept) => {
        baseSrcList.push({
          src: concept.url,
          callback: (img) => { concept.object = img; }
        });
      });
    }
  });
};

export default runPreload;
